import { render } from "./BasicConfigGeneral.vue?vue&type=template&id=dc603368&scoped=true"
import script from "./BasicConfigGeneral.vue?vue&type=script&lang=js"
export * from "./BasicConfigGeneral.vue?vue&type=script&lang=js"

import "./BasicConfigGeneral.vue?vue&type=style&index=0&id=dc603368&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc603368"]])

export default __exports__